/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockReportFilter
 */
export interface StockReportFilter {
    /**
     * 
     * @type {string}
     * @memberof StockReportFilter
     */
    family?: string;
    /**
     * 
     * @type {string}
     * @memberof StockReportFilter
     */
    materialCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StockReportFilter
     */
    materialName?: string;
    /**
     * 
     * @type {number}
     * @memberof StockReportFilter
     */
    qty?: number;
    /**
     * 
     * @type {string}
     * @memberof StockReportFilter
     */
    searchText?: string;
}

/**
 * Check if a given object implements the StockReportFilter interface.
 */
export function instanceOfStockReportFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StockReportFilterFromJSON(json: any): StockReportFilter {
    return StockReportFilterFromJSONTyped(json, false);
}

export function StockReportFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockReportFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'family': !exists(json, 'family') ? undefined : json['family'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'materialName': !exists(json, 'materialName') ? undefined : json['materialName'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'searchText': !exists(json, 'searchText') ? undefined : json['searchText'],
    };
}

export function StockReportFilterToJSON(value?: StockReportFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'family': value.family,
        'materialCode': value.materialCode,
        'materialName': value.materialName,
        'qty': value.qty,
        'searchText': value.searchText,
    };
}

